import { ChakraProvider } from "@chakra-ui/react"
import React from "react"
import { Col, Row } from "react-bootstrap"
import "react-dates/initialize"
import { useTranslation } from "react-i18next"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import "./App.scss"
import { useAppSelector } from "./app/hooks"
import "./assets/css/index.scss"
import AuthedRoute from "./containers/AuthedRoute"
import Consolidations from "./Pages/Consolidations/Consolidations"
import Customers from "./Pages/Customers/Customers"
import Dashboard from "./Pages/Dashboard"
import Dispatchs from "./Pages/Dispatchs/Dispatchs"
import Drops from "./Pages/Drops/Drops"
import EconomyConsols from "./Pages/Economy Consol/EconomyConsols"
import Fulfillments from "./Pages/Fulfillments/FulfillmentRequests"
import Groups from "./Pages/Groups/Groups"
import IncomingOrders from "./Pages/IncomingOrders/IncomingOrders"
import MainContainer from "./Pages/Layout/Container"
import LineHaul from "./Pages/LineHaul/LineHaul"
import Login from "./Pages/Login/Login"
import CreditParcels from "./Pages/Parcels/CreditParcels"
import Parcels from "./Pages/Parcels/Parcels"
import Pick from "./Pages/Picks/Picks"
import PromoCodes from "./Pages/PromoCodes/PromoCodes"
import PurchaseRequest from "./Pages/PurchaseRequest/PurchaseRequest"
import ShippingRates from "./Pages/ShippingRates/ShippingRates"
import Suites from "./Pages/Suites/Suites"
import Surcharges from "./Pages/Surcharges/Surcharges"
import Users from "./Pages/Users/Users"
import ValueAddedServices from "./Pages/ValueAddedServices/ValueAddedServices"
import Warehouses from "./Pages/Warehouses/Warehouses"
import { RootState } from "./store"

const App = () => {
    const { i18n } = useTranslation()
    const mainContainerClasses = `main-container ${i18n.language}`
    const { isAuthed } = useAppSelector((state: RootState) => state.auth)

    return (
        <div className="App">
            <Router>
                <ChakraProvider>
                    <Switch>
                        <MainContainer
                            fluid={true}
                            mainContainerClasses={mainContainerClasses}
                            isAuthed={isAuthed}>
                            {!isAuthed && (
                                <Row className="d-flex justify-content-center align-items-center">
                                    <Col xs={12} sm={12} md={6} lg={3} className="pb-4 mx-auto login-container">
                                        <Route component={Login} path="/login" />
                                    </Col>
                                </Row>
                            )}
                            <AuthedRoute component={Dashboard} path="/" />
                            <AuthedRoute component={Customers} path="/customers" />
                            <AuthedRoute component={Parcels} path="/parcels" />
                            <AuthedRoute component={PromoCodes} path="/promo-codes" />
                            <AuthedRoute component={Suites} path="/suites" />
                            <AuthedRoute component={Consolidations} path="/consolidations" />
                            <AuthedRoute component={EconomyConsols} path="/economy-consols" />
                            <AuthedRoute component={Drops} path="/drop" />
                            <AuthedRoute component={Pick} path="/pick" />
                            <AuthedRoute component={Dispatchs} path="/dispatch" />
                            <AuthedRoute component={Users} path="/admins/users" />
                            <AuthedRoute component={Warehouses} path="/admins/warehouses" />
                            <AuthedRoute component={Groups} path="/admins/groups" />
                            <AuthedRoute component={PurchaseRequest} path="/purchase-requests" />
                            <AuthedRoute component={CreditParcels} path="/parcels/credit-parcels" />
                            <AuthedRoute component={ShippingRates} path="/pricing/shipping-rates" />
                            <AuthedRoute component={ValueAddedServices} path="/pricing/value-added-services" />
                            <AuthedRoute component={Surcharges} path="/pricing/surcharges" />
                            <AuthedRoute component={IncomingOrders} path="/orders" />
                            <AuthedRoute component={LineHaul} path="/linehaul" />
                            <AuthedRoute component={Fulfillments} path="/fulfillments" />
                        </MainContainer>
                    </Switch>
                </ChakraProvider>
            </Router>
        </div>
    )
}

export default App
